import { axiosApi } from '@/services/http/axiosApi'
import { POST_COMPANY_ORDERS } from '@/constants/urls'
import type { CompanyOrdersByCompanyIdResponse } from '@/types/companyOrders.types'
import type { AxiosResponse } from 'axios'

export const getCompanyOrdersByCompanyId = async (
  companyId: string
): Promise<AxiosResponse<CompanyOrdersByCompanyIdResponse>> =>
  await axiosApi.post(POST_COMPANY_ORDERS(companyId), {})
